import React from "react";
import { createRoot } from "react-dom/client";
import { StandardModal } from "src/components";
const MODAL_CONTAINER_ID = "modal-container";

const createModal = (modalHeader, modalBody, easyDismiss, modalOptions = {}) => {
    const modalContainer = document.createElement("div");

    BankDetailsModal.instance.appendChild(modalContainer);
    const root = createRoot(modalContainer);
    BankDetailsModal.roots.set(modalContainer, root);

    const dismissEvent = () => {
        root.unmount();
        BankDetailsModal.roots.delete(modalContainer);
        modalContainer.parentNode?.removeChild(modalContainer);
    };

    root.render(
        <StandardModal
            open={true}
            onClose={easyDismiss ? dismissEvent : undefined}
            title={modalHeader}
            widthMode="large"
            bodyPadding="0"
            paperStyle={{
                width: modalOptions.width,
                maxWidth: modalOptions.maxWidth
            }}
        >
            <div
                style={{
                    padding: "1.5rem clamp(1.25rem, 4vw, 3rem) 2rem",
                    textAlign: "center"
                }}
            >
                {modalBody}
            </div>
        </StandardModal>
    );
};

class BankDetailsModal {
    static instance;
    static roots = new Map();

    static init() {
        let exists = document.getElementById(MODAL_CONTAINER_ID);

        if (exists) {
            BankDetailsModal.instance = exists;
            BankDetailsModal.instance.id = MODAL_CONTAINER_ID;
            document.body.removeChild(BankDetailsModal.instance);
        }

        BankDetailsModal.instance = document.createElement("div");
        BankDetailsModal.instance.id = MODAL_CONTAINER_ID;
        document.body.appendChild(BankDetailsModal.instance);
    }

    /** There can only every be one modal active at a time. */
    static open(modalHeader = "", modalBody = "", easyDismiss = true, modalOptions = {}) {
        if (!BankDetailsModal.instance || !document.getElementById(MODAL_CONTAINER_ID)) {
            BankDetailsModal.init();
        }

        createModal(modalHeader, modalBody, easyDismiss, modalOptions);
    }

    /** Allows for programmatic closing of a modal. */
    static close() {
        if (!BankDetailsModal.instance || !document.getElementById(MODAL_CONTAINER_ID)) {
            console.warn("There is no modal to close.");
            return;
        }

        let modal = document.getElementById(MODAL_CONTAINER_ID);
        if (modal) {
            BankDetailsModal.roots.forEach(root => root.unmount());
            BankDetailsModal.roots.clear();
            modal.parentNode.removeChild(modal);
        }
    }
}

export default BankDetailsModal;
